<template>
  <v-popup
    :isShow="isShow"
    title="Set Referrer Discount"
    @cancel="handleCancel"
    @save="handleSave">
    <el-form
      ref="form"
      :model="formData"
      :rules="rules">
      <!--      <v-radio-group-->
      <!--        v-model="formData.share_discount_type"-->
      <!--        :list="groupList"-->
      <!--        @change="changeType"></v-radio-group>-->
      <div class="form-item">
        <span>Referral discount</span>
        <el-form-item prop="share_discount">
          <!--        <v-select-->
          <!--          v-if="formData.share_discount_type == 2"-->
          <!--          v-model="formData.share_discount"-->
          <!--          valueKey="value"-->
          <!--          :list="discountList"></v-select>-->
          <div class="flex-sb-center">
            <v-select
              v-model="referral_id"
              :list="referral_option_list"
            ></v-select>
            <v-button
              gray
              class="mg-l-10"
              @click="initReferrerId">Default</v-button>
          </div>
        </el-form-item>
      </div>


    </el-form>
  </v-popup>
</template>

<script>
import MixinOptions from '@/mixins/options'
import MixinReferralOption from '@/mixins/referral-option'

export default {
  name: 'SetReferrerDiscount',
  mixins: [MixinOptions,MixinReferralOption],
  props:{
    form:{
      type: Object,
      default: () => {}
    }
  },
  data () {
    const checkDiscount = (rule, value, cb) => {
      const {share_discount_type} = this.formData
      if(share_discount_type == 2 && value == ''){
        cb(new Error(this.$t('placeholder.select')))
      }
      cb()
    }
    return {
      isShow: false,
      groupList:[
        {
          name: 'Referral discount',
          id: 1
        },
        {
          name: 'Special Offer Request',
          id: 2
        }
      ],
      formData:{
        share_discount_type: 1,
        share_discount: ''
      },
      rules:{
        share_discount:[
          {validator: checkDiscount, trigger: ['change', 'blur']}
        ]
      }
    }
  },
  computed:{
    classId(){
      return this.form.class_id
    },
    orderId(){
      let {id} = this.form||{}
      return id
    },
    planType(){
      return this.form.plan_type || null
    },
    discountList(){
      let list = this.globalOptions.max_share_discount || []
      let arr = list.filter(item => {
        if(item.plan_type){
          return item.class_id == this.classId && item.plan_type == this.planType
        }else{
          return item.class_id == this.classId
        }
      })
      let res = []
      if(arr.length){
        let max = arr[0].value
        for(let i=0; i<=max; i++){
          let obj = {
            value: i,
            name: `${i}%`
          }
          res.push(obj)
        }
      }
      return res
    }
  },
  watch:{
    isShow:{
      immediate:true,
      handler(val){
        console.log('val--',val)
        if(val){
          this.mixinNetwork().getOrderReferralList({},true)
        }
      }
    }
  },
  methods: {
    changeDialog(){
      this.isShow = !this.isShow
    },
    handleCancel(){
      this.isShow = false
    },
    handleSave(){
      let {code_discount_info} = this.code_discount_info||{}
      let {  discount_type, discount} = code_discount_info||{}
      this.$refs['form'].validate(valid =>{
        if(valid){
          this.$emit('setReferrerDiscount',{
            share_discount_type: discount_type,
            share_discount: discount
          })
        }
      })
    },
    changeType(){
      this.$refs['form'].clearValidate()
    }
  },
}
</script>
<style lang='scss' scoped>
/deep/.el-radio-group{
  display: flex;
  flex-direction: column;
  height: 50px;
  .el-radio{
    flex: 1;
  }
}
</style>
